import React from "react";
import { Outlet } from "react-router-dom";

const HelpCenterRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default HelpCenterRoot;

